<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [primaryButtonLabel]="'OK'"
    [modalHelpIndex]="modalHelpIndex" [secondaryButtonLabel]="'Cancel'" [isPrimaryBtnEnabled]="isPrimaryBtnEnabled()"
    id="workflow-query" [modalAutomationId]="modalAutomationId" [modalDraggable]=false [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" (closeButtonActionEmt)="closeModal()" (primaryButtonActionEmt)="ok()">
    <div id="topWorkflowContent">
        <res-search [workflowMode]="true"></res-search>
    </div>
    <res-resizer [hidden]="activeSearchType !== 'VECTOR_SET_SEARCH'" #resizer anchor="up"
        parentElementId="workflow-query" resizingElementId="topWorkflowContent" [collapsibleToMinSize]="true"
        secondElementId="bottomWorkflowContent" [initSize]="120" [maxSize]="500" [minSize]="120" [collapsed]="true">
    </res-resizer>
    <div id="bottomWorkflowContent">
        <div [hidden]="activeSearchType === 'BULK_SEARCH'">
            <ul class="nav nav-tabs">
                <li *ngFor="let tab of navigationInfo.tabs" [ngClass]="{'active': summaryType === tab.path }"
                    [attr.data-automation-id]="'workflow-query-' + tab.path + '-tab'" (click)="navigateTo(tab.path)">
                    <a>{{tab.name}}</a>
                </li>
            </ul>
            <res-generic-grid [columnDefs]="columnDefs" [requestInfo]="requestInfo" [rowSelection]="rowSelection"
                *ngIf="navigationInfo.tabs && navigationInfo.tabs.length > 0"
                [automationId]="modalAutomationId + '-grid'" [onSelectionChanged]="onSelectionChanged"
                [rowClassRules]="rowClassRules" [responseCallback]="responseCallback"></res-generic-grid>
        </div>
    </div>
</res-base-modal>